import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutShortPayReport } from "./autogen/AutogenLayoutShortPayReport";

export class ShortPayReport extends AutogenLayoutShortPayReport {
    public override async onLoad() {
        this.textboxUserType.selectedItem = this.textboxUserType.items[0];
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }

    userTypeChanged() {
        const userType = this.textboxUserType.text
        // this.excludeableTextboxUser.textbox.clear();
        // this.excludeableTextboxUser.checkbox.checked = false;
        if (userType.startsWith("Salesperson")) {
            this.excludeableTextboxSalesperson.visible = true;
            this.excludabletextboxOpsUser.visible = false;
            this.excludabletextboxAgents.visible = false;
            this.switchGroupBy.caption = "Group By Salesperson";
            this.switchPagebreak.caption = "Page Break After Each Salesperson";

        } else if (userType.startsWith("Operation")) {
            this.excludeableTextboxSalesperson.visible = false;
            this.excludabletextboxOpsUser.visible = true;
            this.excludabletextboxAgents.visible = false;
            this.switchGroupBy.caption = "Group By Operations User";
            this.switchPagebreak.caption = "Page Break After Each Operations User";
        } else if (userType.startsWith("Agent")) {
            this.excludeableTextboxSalesperson.visible = false;
            this.excludabletextboxOpsUser.visible = false;
            this.excludabletextboxAgents.visible = true;
            this.switchGroupBy.caption = "Group By Agent";
            this.switchPagebreak.caption = "Page Break After Each Agent";
        }
    }

    switchPageBreakChange() {
        this.switchGroupBy.checked = this.switchPagebreak.checked;
    }
}
